(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-progress"] = factory();
	else
		root["vue-progress"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueProgress.vue?vue&type=template&id=e6c7c232&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-progress"},[_c('ol',{staticClass:"sf-progress__steps"},[_vm._l((_vm.steps),function(step,index){return [_c('li',{staticClass:"sf-progress__step",class:{ 'sf-progress__step--current': step.current, 'sf-progress__step--done': step.done, 'sf-progress__step--pending': step.pending }},[_c('span',{staticClass:"sf-progress__count",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(index + 1)),_c('svg',{staticClass:"nip--mobile",staticStyle:{"left":"-6px"},attrs:{"width":"8","height":"24","viewBox":"0 0 8 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 6.99382e-07C8 2.56753 6 7.24455 6 12C6 16.5053 8 21.081 8 24C4.50002 19.5 4.00002 12.9999 -1.82817e-07 12.9999C0 12 1.72453e-06 12 -9.61646e-07 10.9999C4.00002 10.9999 4.50002 4.5 8 6.99382e-07Z"}})]),_c('svg',{staticClass:"nip--mobile",staticStyle:{"right":"-6px"},attrs:{"width":"8","height":"24","viewBox":"0 0 8 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.53674e-07 -2.98182e-05C1.17813e-06 2.56749 2 7.24452 2 12C2 16.5053 8.89288e-07 21.081 1.14447e-06 24C3.49998 19.5 3.99998 12.9999 8 12.9999C8 12 8 12 8 10.9999C3.99998 10.9999 3.49998 4.49997 9.53674e-07 -2.98182e-05Z"}})]),_c('svg',{staticClass:"nip--desktop",staticStyle:{"left":"-14px"},attrs:{"width":"16","height":"26","viewBox":"0 0 16 26","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.5 0.499261L13.5 12.9993L15.5 25.4993L12.3701 20.7001C9.64386 16.5198 4.99073 13.9992 -9.41786e-07 13.9992L-1.00536e-06 11.9992C4.99074 11.9992 9.64387 9.47863 12.3702 5.29834L15.5 0.499261Z"}})]),_c('svg',{staticClass:"nip--desktop",staticStyle:{"right":"-14px"},attrs:{"width":"16","height":"26","viewBox":"0 0 16 26","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.5 0.499261L2.5 12.9993L0.5 25.4993L3.62986 20.7001C6.35614 16.5198 11.0093 13.9992 16 13.9992L16 11.9992C11.0093 11.9992 6.35613 9.47863 3.62985 5.29834L0.5 0.499261Z"}})])]),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(index + 1)+". lépés:")]),_c('span',{staticClass:"sf-progress__text"},[_vm._v(_vm._s(step.text))]),_c('span',{staticClass:"sr-only"},[(step.current)?[_vm._v(", Ön itt jár.")]:(step.done)?[_vm._v(", kész.")]:[_vm._v(", inaktív.")]],2),(step.editUrl && !step.current)?_c('a',{staticClass:"sf-link sf-progress__modify",attrs:{"href":step.editUrl + '?edit=true',"aria-label":step.text + ' szerkesztése'},on:{"click":function($event){return _vm.emitModification(index)}}},[_vm._t("default",function(){return [_vm._v("Módosítom")]})],2):_vm._e()])]})],2),(_vm.hasSelect)?_c('div',{staticClass:"select-wrapper"},[_c('label',{staticClass:"sr-only",attrs:{"id":_vm.uuid + '-label',"for":_vm.uuid}},[_vm._v("Lépés kiválasztása")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobileStep),expression:"mobileStep"}],attrs:{"id":_vm.uuid},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mobileStep=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.gotoUrl]}},_vm._l((_vm.steps),function(step,index){return _c('option',{attrs:{"disabled":!(step.editUrl && !step.current)},domProps:{"value":step}},[_vm._v(_vm._s(step.text)),(_vm.stepIndex)?[_vm._v("("+_vm._s(index + 1)+"/"+_vm._s(_vm.steps.length)+")")]:_vm._e()],2)}),0),_c('svg',{attrs:{"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1L5 5L9 1","stroke":"#52AE30","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e(),(!_vm.hasSelect)?_c('div',{staticClass:"title-wrapper"},[_c('p',[_vm._v(_vm._s(_vm.mobileStep.text))])]):_vm._e()])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueProgress.vue?vue&type=script&lang=js&

/**
 * @typedef Step
 * @type {object}
 * @property {string} text - Text of the current step.
 * @property {string} editUrl - URL to edit the current step .
 * @property {boolean} current - Sets the current step active.
 * @property {boolean} done - Sets the current step done.
 * @property {boolean} pending - Sets the current step done.
 */
/* harmony default export */ const VueProgressvue_type_script_lang_js_ = ({
	name: 'VueProgress',
	data: () => ({
		mobileStep: null
	}),
	props: {
		/**
		 * Array of steps containing the `text`, `editUrl` and `current`, `done`, `pending` status of each step.
		 * @type {Array<Step>}
		 */
		steps: {
			type: Array,
			required: true
		},
		/**
		 * Decides whether the current step and the number of steps are visible on mobile
		 */
		stepIndex: {
			type: Boolean,
			required: false,
			default: true
		},
		hasSelect: {
			default: true
		}
	},
	watch: {
		steps: {
			handler(val) {
				if (val && val.length > 0) {
					this.mobileStep = val.find((item) => item.current);
				}
			},
			immediate: true
		}
	},
	methods: {
		gotoUrl() {
			const index = this.steps.findIndex((step) => step.text == this.mobileStep.text && step.editUrl == this.mobileStep.editUrl);
			this.emitModification(index);
			window.location.href = this.mobileStep.editUrl + '?edit=true';
		},
		emitModification(index) {
			this.$emit('modify', index);
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueProgress.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueProgressvue_type_script_lang_js_ = (VueProgressvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueProgress.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueProgressvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "e6c7c232",
  null
  
)

/* harmony default export */ const VueProgress = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueProgress);


__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-progress.umd.js.map